export const europeanCountryList = [
    "austria",
    "belgium",
    "bulgaria",
    "croatia",
    "cyprus",
    "czech republic",
    "czechia",
    "denmark",
    "estonia",
    "finland",
    "france",
    "germany",
    "greece",
    "hungary",
    "ireland",
    "italy",
    "latvia",
    "lithuania",
    "luxembourg",
    "malta",
    "netherlands",
    "poland",
    "portugal",
    "romania",
    "slovakia",
    "slovenia",
    "spain",
    "sweden",
] as const

/** ISO 3166-1 alpha-2 → name matching an entry in `europeanCountryList`. */
const EU_ISO_TO_LIST_NAME: Record<string, (typeof europeanCountryList)[number]> = {
  AT: "austria",
  BE: "belgium",
  BG: "bulgaria",
  HR: "croatia",
  CY: "cyprus",
  CZ: "czechia",
  DK: "denmark",
  EE: "estonia",
  FI: "finland",
  FR: "france",
  DE: "germany",
  GR: "greece",
  HU: "hungary",
  IE: "ireland",
  IT: "italy",
  LV: "latvia",
  LT: "lithuania",
  LU: "luxembourg",
  MT: "malta",
  NL: "netherlands",
  PL: "poland",
  PT: "portugal",
  RO: "romania",
  SK: "slovakia",
  SI: "slovenia",
  ES: "spain",
  SE: "sweden",
}

/** If `countryCode` is a European list country (ISO from e.g. ipinfo), return its list name; else the code unchanged. */
export function resolveEuropeanCountryCookieValue(countryCode: string): string {
  return EU_ISO_TO_LIST_NAME[countryCode.toUpperCase()] ?? countryCode
}

/** Reverse of `resolveEuropeanCountryCookieValue`.
 *  If `value` is a European list name (e.g. "spain"), return its ISO code (e.g. "ES").
 *  If it is already an ISO code or anything else, return it unchanged.
 */
export function resolveISOFromEuropeanName(value: string): string {
  const lower = value.toLowerCase()
  const entry = Object.entries(EU_ISO_TO_LIST_NAME).find(([, name]) => name === lower)
  return entry ? entry[0] : value
}